<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.motivo"
                    label="Motivo"
                    v-model="model.descricao"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {

    computed: {
        validations() {

            return {
                motivo: {
                    required: true,
                    max: 100,
                    min: 3,
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        model: {
            id: '',
            descricao: '',
        },
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.motivo.findIndex((obj => obj.id == this.item.id));

                const data = this.data.model.motivo[objId]

                this.model.id = data.id
                this.model.descricao = data.descricao
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.index == null) {

                            this.model.id = this.uniqueId('motivo'+ new Date().getTime())
                        }

                        const param = {
                            id: this.model.id,
                            descricao: this.model.descricao,
                        }

                        if (this.hasIndex) {

                            const objId = this.data.model.motivo.findIndex((obj => obj.id == this.item.id));

                            this.$set(this.data.model.motivo, objId, this.clone(param))
                        }
                        else {

                            this.data.model.motivo.push(this.clone(param))
                        }

                        this.$emit('save', this.clone(param))
                })
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>